<!--企业标签查询-->
<template>
  <div class="enterprise-tag-query-container">
    <header-index/>
    <div class="enterprise-tag-query-content">
      <div class="enterprise-tag-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item>{{ queryName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="enterprise-tag-query-menu">
        <div class="tag-content" v-show="queryName!='新增企业'">
          <span class="small-title">关键词</span>
          <div class="tag-menu">
            <div class="tag-radio-container">
              <el-input v-model="keyword" placeholder="请输入查询关键词，如“帮企”" @keyup.enter.native="getEnterpriseInfo" style="width: 50%"/>
            </div>
          </div>
        </div>

        <div class="tag-content" v-show="queryName!='新增企业'">
          <span class="small-title">类型</span>
          <div class="tag-menu">
            <div :class="show1 ? 'tag-radio-container' : 'show-tag-radio-container'">
              <el-radio-group v-model="enterpriseType">
                <el-radio-button :label="''">不限</el-radio-button>
                <el-radio-button v-for="list of enterpriseTypeList" :label="list.id">{{ list.name }}</el-radio-button>
              </el-radio-group>
            </div>
            <el-link :underline="false" @click="show1=show1 ? false : true" class="el-show-link">
              {{ show1 ? '更多' : '收起' }}
              <i :class="show1 ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
            </el-link>
          </div>
        </div>
        <div class="tag-content">
          <span class="small-title">省份地区</span>
          <div class="tag-menu">
            <div :class="show2 ? 'tag-radio-container' : 'show-tag-radio-container'">
              <el-radio-group v-model="province" @change="changeProvince">
                <el-radio-button :label="''">不限</el-radio-button>
                <el-radio-button v-for="list of regionList" :label="list.id">{{ list.name }}</el-radio-button>
              </el-radio-group>
            </div>
            <el-link :underline="false" @click="show2=show2 ? false : true" class="el-show-link">
              {{ show2 ? '更多' : '收起' }}
              <i :class="show2 ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
            </el-link>
          </div>
        </div>
        <div class="tag-content" v-if="countyList.length>0">
          <span class="small-title">区县</span>
          <div class="tag-menu">
            <div :class="show3 ? 'tag-radio-container' : 'show-tag-radio-container'">
              <el-radio-group v-model="county">
                <el-radio-button :label="''">不限</el-radio-button>
                <el-radio-button v-for="list of countyList" :label="list.id">{{ list.name }}</el-radio-button>
              </el-radio-group>
            </div>
            <el-link :underline="false" @click="show3=show3 ? false : true" class="el-show-link">
              {{ show3 ? '更多' : '收起' }}
              <i :class="show3 ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
            </el-link>
          </div>
        </div>
        <div class="tag-content">
          <span class="small-title">行业分类</span>
          <div class="tag-menu">
            <div :class="show4 ? 'tag-radio-container' : 'show-tag-radio-container'">
              <el-radio-group v-model="industry">
                <el-radio-button :label="''">不限</el-radio-button>
                <el-radio-button v-for="list of industryList" :label="list.rid">{{ list.name }}</el-radio-button>
              </el-radio-group>
            </div>
            <el-link :underline="false" @click="show4=show4 ? false : true" class="el-show-link">
              {{ show4 ? '更多' : '收起' }}
              <i :class="show4 ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
            </el-link>
          </div>
        </div>
        <div class="tag-content" v-show="queryName=='新增企业'">
          <span class="small-title">状态</span>
          <div class="tag-radio-container">
            <el-radio-group v-model="enterpriseStatus">
              <el-radio-button :label="''">不限</el-radio-button>
              <el-radio-button v-for="list of enterpriseStatusList" :label="list">{{ list }}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="tag-content" v-show="queryName=='新增企业'">
          <span class="small-title">年份</span>
          <div class="tag-radio-container">
            <el-radio-group v-model="year">
              <el-radio-button :label="''">不限</el-radio-button>
              <el-radio-button v-for="list of yearList" :label="list">{{ list }}</el-radio-button>
            </el-radio-group>
            <el-input v-model="customYear" style="width: 120px;" placeholder="自定义" oninput="value=value.replace(/[^\d]/g,'')" maxLength="4"/>
            <el-link type="primary" :underline="false" @click="changeYear">确定</el-link>
          </div>
        </div>
        <div class="tag-content" v-show="queryName!='新增企业'">
          <span class="small-title">注册资本</span>
          <div class="tag-radio-container">
            <el-radio-group v-model="registerCapital">
              <el-radio-button :label="''">不限</el-radio-button>
              <el-radio-button v-for="list of registerCapitalList" :label="list.name">{{ list.name }}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <div class="tag-content" v-show="queryName!='新增企业'">
          <span class="small-title">成立年限</span>
          <div class="tag-radio-container">
            <el-radio-group v-model="period">
              <el-radio-button :label="''">不限</el-radio-button>
              <el-radio-button v-for="list of periodList" :label="list.name">{{ list.name }}</el-radio-button>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="enterprise-tag-info">
        <p class="enterprise-title">搜索到<span class="red-span">{{ tablePage.total }}</span>个结果</p>
        <template v-if="enterpriseInfo.length>0 && queryName!='企业名称查询'">
          <div class="enterprise-info-list" v-for="info of enterpriseInfo" @click="enterpriseDetails(info)">
            <el-container>
              <el-aside width="110px">
                <el-image shape="square" fit="contain" style="width: 90px;height: 90px;display: flex;align-items: center;justify-content: center;border: 1px solid #dddddd;padding: 5px;"
                          draggable="false" :src="info.companyLogo" v-if="info.companyLogo!=null &&
                    info.companyLogo!='' && info.companyLogo!='None' &&
                    info.companyLogo!='https://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    info.companyLogo!='http://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    info.companyLogo!='https://aiqicha.baidu.com/static/pc/photo/logo.png' &&
                    info.companyLogo!='http://aiqicha.baidu.com/static/pc/photo/logo.png'">
                  <div slot="error" class="image-slot">
                    <div class="logo-keyword" :style="'background:rgb(39, 64, 139);'" v-if="info.entLogoWord">
                      <span v-for="(logo,index) of logoWord(info.entLogoWord)" class="logo-word" v-if="index<4">{{ logo }}</span>
                    </div>
                    <div class="logo-keyword" :style="'background:'+createRandomColor()+''" v-else>
                      <span v-for="(b,index) of logoWord(info.companyName)" class="logo-word" v-if="index<4">{{b}}</span>
                    </div>
                  </div>
                </el-image>
                <el-avatar shape="square" fit="scale-down" v-else :size="100">
                  <div class="logo-keyword" :style="'background:'+createRandomColor()+''" v-if="info.entLogoWord">
                    <span v-for="(ent,index) of logoWord(info.entLogoWord)" class="logo-word" v-if="index<4">{{ ent }}</span>
                  </div>
                  <div class="logo-keyword" :style="'background:'+createRandomColor()+''" v-else>
                    <span v-for="(logo,index) of logoWord(info.companyName)" class="logo-word" v-if="index<4">
                      {{ logo }}
                    </span>
                  </div>
                </el-avatar>
              </el-aside>
              <el-main>
                <label class="item-describe SourceHanSansCN">{{ info.companyName }}</label>
                <!--1在业 2存续 3吊销 4注销 5迁出-->
                <span v-if="info.status!=null">
                  <i class="label-green" style="float: right;"
                     v-if="info.status=='开业' || info.status=='在业' || info.status==1">{{ info.status }}</i>
                  <i class="label-red" style="float: right;" v-else-if="!info.status">未知</i>
                  <i class="label-red" style="float: right;" v-else>{{ info.status }}</i>
                </span>
                <div style="margin-top: 15px;">
                  <i class="item-label" v-for="sign of info.kjLabel">{{ sign }}</i>
                </div>
                <div class="item-small" style="padding-top: 15px;">
                  <span>法定代表人：</span>
                  <span style="color: #333333">{{ info.mname  || '-'}}</span>
                  <span style="padding-left: 40px;">注册资本：</span>
                  <span style="color: #333333">{{ info.registeredCapital  || '-'}}</span>
                  <span style="padding-left: 40px;">成立时间：</span>
                  <span style="color: #333333">{{ info.establishTime  || '-'}}</span>
                  <span style="padding-left: 40px;">统一社会信用代码：</span>
                  <span style="color: #333333">{{ info.code || '-'}}</span>
                </div>
                <div class="item-small">
                  <span>地址：</span>
                  <span style="color: #333333">{{ info.address==0 || !info.address || info.address=='0' ? '-' : info.address}}</span>
                </div>
              </el-main>
            </el-container>
          </div>
          <div style="padding:10px 10px 0px 20px;">
            <page :total="tablePage.total" @currentPage="currentPage" :limit="tablePage.pageSize"/>
          </div>
        </template>
        <template v-else-if="enterpriseInfo.length>0 && queryName=='企业名称查询'">
          <div class="enterprise-info-list" v-for="info of enterpriseInfo" @click="enterpriseDetails(info)">
            <el-container>
              <el-aside width="110px">
                <el-image shape="square" fit="contain" style="width: 90px;height: 90px;display: flex;align-items: center;justify-content: center;border: 1px solid #dddddd;padding: 5px;"
                          draggable="false" :src="info.companyLogo" v-if="info.companyLogo!=null &&
                    info.companyLogo!='' && info.companyLogo!='None' &&
                    info.companyLogo!='https://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    info.companyLogo!='http://aiqicha.baidu.com//static/pc/photo/logo.png' &&
                    info.companyLogo!='https://aiqicha.baidu.com/static/pc/photo/logo.png' &&
                    info.companyLogo!='http://aiqicha.baidu.com/static/pc/photo/logo.png'">
                  <div slot="error" class="image-slot">
                    <div class="logo-keyword" :style="'background:rgb(39, 64, 139);'" v-if="info.entLogoWord">
                      <span v-for="(logo,index) of logoWord(info.entLogoWord)" class="logo-word" v-if="index<4">{{ logo }}</span>
                    </div>
                    <div class="logo-keyword" :style="'background:'+createRandomColor()+''" v-else>
                      <span v-for="(b,index) of logoWord(info.companyName)" class="logo-word" v-if="index<4">{{b}}</span>
                    </div>
                  </div>
                </el-image>
                <el-avatar shape="square" fit="scale-down" v-else :size="100">
                  <div class="logo-keyword" :style="'background:'+createRandomColor()+''" v-if="info.entLogoWord">
                    <span v-for="(ent,index) of logoWord(info.entLogoWord)" class="logo-word" v-if="index<4">{{ ent }}</span>
                  </div>
                  <div class="logo-keyword" :style="'background:'+createRandomColor()+''" v-else>
                    <span v-for="(logo,index) of logoWord(info.companyName)" class="logo-word" v-if="index<4">
                      {{ logo }}
                    </span>
                  </div>
                </el-avatar>
              </el-aside>
              <el-main>
                <label class="item-describe SourceHanSansCN">{{ info.companyName }}</label>
                <!--1在业 2存续 3吊销 4注销 5迁出-->
                <span v-if="info.status!=null">
                  <i class="label-green" style="float: right;"
                     v-if="info.status=='开业' || info.status=='在业' || info.status==1">{{ info.status }}</i>
                  <i class="label-red" style="float: right;" v-else-if="!info.status">未知</i>
                  <i class="label-red" style="float: right;" v-else>{{ info.status }}</i>
                </span>
                <div style="margin-top: 15px;">
                  <i class="item-label" v-for="sign of info.technologicalEnterpriseLabel">{{ sign }}</i>
                </div>
                <div class="item-small" style="padding-top: 15px;">
                  <span>法定代表人：</span>
                  <span style="color: #333333">{{ info.mname  || '-'}}</span>
                  <span style="padding-left: 40px;">注册资本：</span>
                  <span style="color: #333333">{{ info.registeredCapital  || '-'}}</span>
                  <span style="padding-left: 40px;">成立时间：</span>
                  <span style="color: #333333">{{ info.establishTime  || '-'}}</span>
                  <span style="padding-left: 40px;">统一社会信用代码：</span>
                  <span style="color: #333333">{{ info.unifiedSocialCreditCode || '-'}}</span>
                </div>
                <div class="item-small">
                  <span>地址：</span>
                  <span style="color: #333333">{{ info.address==0 || !info.address || info.address=='0' ? '-' : info.address}}</span>
                </div>
              </el-main>
            </el-container>
          </div>
          <div style="padding:10px 10px 0px 20px;">
            <page :total="tablePage.total" @currentPage="currentPage" :limit="tablePage.pageSize"/>
          </div>
        </template>
        <template v-else>
          <el-empty description="暂无内容"/>
        </template>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import cityJson from "@/static/cityJson.json";
import {technologyEnterprise, getEnterpriseStatus, getIndustry,searchCompany,
  newBusinessList,technologyEnterpriseCompanyList,technologyEnterCapital,technologyEstYear} from '@/api/enterprise_searchApi'
import regionList from '@/static/marketCityList.json'
import page from "@/components/page/pages";
export default {
  name: "enterpriseTagQuery",
  components: {Hang, Home_footer, HeaderIndex,page},
  data() {
    return {
      queryName: '',
      cid: 0,
      pName: '',
      cityList: {},
      enterpriseType: '',
      enterpriseTypeList: [],
      enterpriseStatus: '',
      enterpriseStatusList: [],
      industry: '',
      industryList: [],
      year: '',
      yearList: [],
      customYear: '',
      regionList: regionList,
      province: '',
      county: '',
      countyList: [],
      show1: true,
      show2: true,
      show3: true,
      show4: true,
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      enterpriseInfo:[],
      registerCapital:'',
      registerCapitalList:[],
      minZczb:'',
      maxZczb:'',
      period:'',
      periodList:[],
      minYear:'',
      maxYear:'',
      keyword:'',
      regCap:[],
      establishmentDate:[],
    }
  },
  watch: {
    year(newVal, oldVal) {
      if (newVal != oldVal) {
        this.tablePage.currentPage = 1;
        this.getEnterpriseInfo();
      }
    },
    enterpriseType(newVal, oldVal) {
      if (newVal != oldVal) {
        this.tablePage.currentPage = 1;
        this.getEnterpriseInfo();
      }
    },
    county(newVal, oldVal) {
      if (newVal != oldVal) {
        this.tablePage.currentPage = 1;
        this.getEnterpriseInfo();
      }
    },
    industry(newVal, oldVal) {
      if (newVal != oldVal) {
        this.tablePage.currentPage = 1;
        this.getEnterpriseInfo();
      }
    },
    enterpriseStatus(newVal, oldVal) {
      if (newVal != oldVal) {
        this.tablePage.currentPage = 1;
        this.getEnterpriseInfo();
      }
    },
    registerCapital(newVal, oldVal) {
      if (newVal != oldVal) {
        this.regCap=[];
        if (newVal!='') {
          for (let list of this.registerCapitalList) {
            if (list.name == newVal) {
              this.maxZczb = list.maxZczb;
              this.minZczb = list.minZczb;
              this.regCap.push(list.index);
            }
          }
        }else {
          this.maxZczb='';
          this.minZczb='';
        }
        this.tablePage.currentPage = 1;
        this.getEnterpriseInfo();
      }
    },
    period(newVal, oldVal) {
      if (newVal != oldVal) {
        this.establishmentDate=[];
        if (newVal!=''){
          for (let list of this.periodList) {
            if (list.name === newVal) {
              this.maxYear=list.maxZczb;
              this.minYear=list.minZczb;
              this.establishmentDate.push(list.index);
            }
          }
        }else{
          this.maxYear='';
          this.minYear='';
        }
        this.tablePage.currentPage = 1;
        this.getEnterpriseInfo();
      }
    },
    province(newVal, oldVal) {
      if (newVal != oldVal) {
        this.tablePage.currentPage = 1;
        this.getEnterpriseInfo();
      }
    },
    // 当searchData的值发生改变时触发
    keyword: {
      handler(newVal, oldVal) {
        this.tablePage.currentPage = 1;
        this.getEnterpriseInfo();
      },
      deep: true
    }
  },
  computed:{
    logoWord(){
      return function (word){
        if (word)
          return word.split('');
        else
          return [];
      }
    }
  },
  methods: {
    /*科技型企业分类*/
    getTechnologyEnterprise() {
      technologyEnterprise().then(res => {
        if (res.code == 200) {
          this.enterpriseTypeList = res.content;
        }
      })
    },
    /*获取企业状态*/
    getEnterpriseState() {
      getEnterpriseStatus().then(res => {
        if (res.code == 200) {
          this.enterpriseStatusList = res.content;
        }
      })
    },
    /*获取行业分类*/
    getIndustryList() {
      getIndustry().then(res => {
        if (res.code == 200) {
          this.industryList = res.content;
        }
      })
    },
    /*年份处理*/
    handleDate() {
      let date = new Date();
      let year = date.getFullYear();
      for (let a = 0; a < 8; a++) {
        this.yearList.push(year)
        year--
      }
    },
    changeProvince(value) {
      if (value) {
        for (let item of this.regionList) {
          if (value == item.id) {
            if (item.id == 110000 || item.id == 120000 || item.id == 310000 || item.id == 500000) {
              this.countyList = item.children[0].children;
            } else {
              this.countyList = item.children;
            }
          }
        }
      } else {
        this.county = '';
        this.countyList = [];
      }
    },
    /*获取企业列表*/
    getEnterpriseInfo(){
      if (this.queryName=='新增企业'){
        newBusinessList({
          cityCode: this.county || 0,
          industryThreeId: this.industry || 0,
          industryTwoId: 0,
          lat: "",
          lng: "",
          page: this.tablePage.currentPage,
          pageLimit: this.tablePage.pageSize,
          status: this.enterpriseStatus || 0,
          type: 2,/*获取城市的方式（1：定位获取城市，2：手动选择城市）*/
          year: this.year || 0
        }).then(res=>{
          if (res.code==200){
            this.tablePage.total = parseInt(res.content.total);
            this.enterpriseInfo = res.content.rows;
            console.log(res);
          }
        })
      }else if (this.queryName=='企业名称查询'){
        let level=0;
        if (this.province){
          if (this.province == 500000 || this.province == 110000 || this.province == 120000 || this.province == 310000) {
            level=1;
          }
        }
        searchCompany({
          administrativeSanction: -1,
          areaId: this.county && level==1 ? [this.county] : [],
          bidding: -1,
          capitalType: [],
          chattelMortgage: -1,
          cityId: this.county && level==0 ? [this.county] : [],
          clearInformation: -1,
          companyType: [],
          copyrightWorks: -1,
          customEndYear: "",
          customStartYear: "",
          dishonestInformation: -1,
          email: -1,
          environmentalProtectionPunishment: -1,
          /*成立年限*/
          establishmentDate: this.establishmentDate,
          financingId: [],
          importExportCredit: -1,
          industryOneId:this.industry ? [this.industry]:[],
          industryTwoId: [],
          insuredPersonsEnd: "",
          insuredPersonsNumber: [],
          insuredPersonsStart: "",
          keyword: this.keyword,
          page: this.tablePage.currentPage,
          patentInformation: -1,
          phone: -1,
          provinceId: this.province ? [this.province] : [],
          regCap: this.regCap,
          softwareCopyright: -1,
          sortNum: "",
          status: [],
          taxRating: -1,
          taxpayer: -1,
          trademarkInformation: -1,
          type: [],
          verdict: -1,
          website: -1,
          technologicalEnterpriseId:this.enterpriseType || -1,
          organizationId: [],
          patentType: []
        }).then(res=>{
          if (res.code==200){
            this.tablePage.total = parseInt(res.content.total);
            this.enterpriseInfo = res.content.rows;
            console.log(res);
          }
        })
      } else {
        technologyEnterpriseCompanyList({
          cityCode: this.county || (this.province!='' ? this.province : 0),
          id: this.enterpriseType || 0,
          industryThreeId: this.industry || 0,
          industryTwoId: 0,
          keyword: this.keyword,
          maxEstYear: this.maxYear,
          maxZczb: this.maxZczb,
          minEstYear: this.minYear,
          minZczb: this.minZczb,
          page: this.tablePage.currentPage,
          pageLimit: this.tablePage.pageSize,
          yearType: 0
        }).then(res=>{
          if (res.code==200){
            this.tablePage.total = parseInt(res.content.total);
            this.enterpriseInfo = res.content.rows;
            console.log(res);
          }
        })
      }
    },
    /*随机生成颜色值*/
    createRandomColor() {
      let num=Math.floor(Math.random()*9+1);
      let colorList=['#7db3d9','#d1ae9d','#ca8484','#bc9edd','#8B658B','#B22222','#27408B','#008B8B','#5D478B','#68228B'];
      return colorList[num];
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getEnterpriseInfo();
    },
    /*自定义年份*/
    changeYear(){
      this.year=this.customYear;
    },
    /*科技型企业注册资本*/
    getTechnologyEnterCapital(){
      technologyEnterCapital().then(res=>{
        if (res.code==200){
          for (let a in res.content){
            res.content[a].index=parseInt(a)+1;
          }
          this.registerCapitalList=res.content;
        }
      })
    },
    /*获取成立年限*/
    getPeriod(){
      technologyEstYear().then(res=>{
        if (res.code==200){
          for (let a in res.content){
            res.content[a].index=parseInt(a)+1;
          }
          this.periodList=res.content;
          console.log(this.periodList);
        }
      })
    },
    enterpriseDetails(info){
      let routeData = this.$router.resolve({
        name: "enterpriseDetails",
        path: '/enterpriseDetails/index',
        query: {id:info.cid}
      });
      window.open(routeData.href, '_blank')
    }
  },
  mounted() {
    /*for (let item of this.regionList) {
      if (this.cityList.id == item.id) {
        this.province = item.id;
        if (item.id == 110000 || item.id == 120000 || item.id == 310000 || item.id == 500000) {
          this.countyList = item.children[0].children;
        } else {
          this.countyList = item.children;
        }
      }
    }*/
    this.getTechnologyEnterprise();
    this.getEnterpriseState();
    this.getIndustryList();
    this.getTechnologyEnterCapital();
    this.getPeriod();
    this.handleDate();

  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.pName = this.$route.query.pName;
    this.queryName = this.$route.query.searchType;
    this.enterpriseType = this.$route.query.enterpriseType;
    this.keyword = this.$route.query.keyword;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
  },

}
</script>
<style scoped>
.enterprise-tag-query-container >>> .enterprise-tag-query-content .enterprise-tag-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}

.enterprise-tag-query-container >>> .enterprise-tag-query-content .enterprise-tag-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.enterprise-tag-query-container >>> .enterprise-tag-query-content .enterprise-tag-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.enterprise-tag-query-container >>> .enterprise-tag-query-content .enterprise-tag-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.enterprise-tag-query-container >>> .enterprise-tag-query-content .enterprise-tag-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.enterprise-tag-query-container >>> .enterprise-tag-query-content .enterprise-tag-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}

.enterprise-tag-query-container >>> .enterprise-tag-query-content .enterprise-tag-breadcrumb .el-breadcrumb__inner a,
.enterprise-tag-query-container >>> .enterprise-tag-query-content .enterprise-tag-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.enterprise-tag-query-container >>> .enterprise-tag-query-content .enterprise-tag-query-menu .tag-content .el-radio-button__inner {
  background: #FFF;
  border: none;
  font-weight: 500;
  color: #333333;
  padding: 10px;
  font-size: 14px;
  border-radius: 6px;
  margin-right: 10px;
}

.enterprise-tag-query-container >>> .enterprise-tag-query-content .enterprise-tag-query-menu .tag-content .el-input__inner {
  height: 36px;
  line-height: 36px;
}

.enterprise-tag-query-container >>> .enterprise-tag-query-content .enterprise-tag-query-menu .tag-content .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FFFFFF;
  background-color: #1637FF;
  border: none;
  -webkit-box-shadow: 0 0 0 0 #333333;
  box-shadow: 0 0 0 0 #333333;
}
.enterprise-tag-query-container >>> .el-avatar > img {
  display: block;
  height: 100%;
  width: 100%;
  vertical-align: middle;
}

.enterprise-tag-query-container >>> .el-avatar {
  background: white;
  border: 0.0625rem solid rgba(0, 0, 0, .15);
  border-radius: 6px;
  padding: 0.3125rem;
}
.enterprise-tag-query-container >>> .el-card__body, .el-main {
  padding: 0px 0px 0px 15px;
}
.enterprise-tag-query-container >>> .el-link.el-link--primary {
  color: #1637FF;
  margin-left: 10px;
  font-size: 14px;
}
</style>
<style scoped lang="scss">
.enterprise-tag-query-container {
  background: #E7E9F5;

  .enterprise-tag-query-content {
    padding: 10px 18%;
    background: #E7E9F5;
    min-width: 76rem;
    .enterprise-tag-query-menu {
      padding: 30px 20px 10px;
      margin-top: 10px;
      background: #FFFFFF;

      .tag-content {
        display: flex;
        justify-content: left;
        padding-bottom: 20px;

        .small-title {
          font-size: 14px;
          font-family: "SourceHanSansCN";
          color: #666666;
          display: inline-block;
          width: 85px;
          padding-top: 5px;
        }

        .tag-menu {
          display: flex;
          justify-content: space-between;
          width: 93%;
          align-items: self-start;

          .tag-radio-container {
            width: 92%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          .show-tag-radio-container {
            width: 93%;
          }

          .el-show-link {
            margin-left: 20px;
            padding: 7px 0px 0px;
            font-size: 14px;
            color: #999999;
            font-family: "SourceHanSansCN";
          }
        }
      }
    }
    .enterprise-tag-info{
      background: #FFFFFF;
      min-height: 49.8vh;
      .enterprise-title {
        font-size: 14px;
        font-family: 'SourceHanSansCN';
        color: #333333;
        display: flex;
        margin-block-end: 0px;
        margin-block-start: 0px;
        border-top: 20px solid #E7E9F5;
        padding: 20px;
        border-bottom: 1px solid #F5F5F5;
        .red-span {
          color: #fe273b;
        }
      }
      .enterprise-info-list {
        padding: 20px;
        border-bottom: 1px solid #E7E9F5;
        .logo-keyword {
          height: 88px;
          width: 88px;
          font-size: 28px;
          color: #ffffff;
          font-weight: 500;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
          margin: 0px;
          .logo-word {
            width: 36%;
            height: 34%;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .item-label {
          border: 1px solid #E1E5FF;
          padding: 5px 8px;
          color: #1637FF;
          background: #E1E5FF;
          font-style: normal;
          border-radius: 6px;
          margin-right: 10px;
        }

        .label-red {
          padding: 5px 8px;
          color: #FF0000;
          background: #ffffff;
          font-style: normal;
          border-radius: 6px;
          margin-right: 10px;
          border: 1px solid #FF0000;
        }

        .label-green {
          padding: 5px 15px;
          color: #00A980;
          background: #FFFFFF;
          font-style: normal;
          border-radius: 4px;
          margin-right: 10px;
          border: 1px solid #00A980;
        }

        .item-describe {
          padding: 20px 0 10px;
          font-size: 18px;
          font-weight: 600;
          color: #333333;
        }

        .item-small {
          color: #999999;
          font-size: 14px;
          padding-top: 5px;
        }
      }
    }
  }
}
</style>